import { DocumentModel } from "./document.model";

export class MongoCursorModel extends DocumentModel {
  constructor(
    private method?: string,
    private page?: number,
    private ids?: string[],
    private isSearch?: boolean,
    private $nor: string[] = [],
    private tabs?: string,
  ){
    super();
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/models/mongoCursor.model.ts